import { Component, OnInit, ViewChild } from '@angular/core';
import { AuditedProjectResult, ProjectInfo } from './models/project-info.model';
import { MatTableDataSource } from '@angular/material/table';
import { AuditFrequencyModel } from './models/audit-frequency.model';
import { MatPaginator} from '@angular/material/paginator';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ProjectListingService } from 'src/app/services/Audit/project-listing.service';
import { ProjectFilter } from './models/project-filter';
import { MatSort } from '@angular/material/sort';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { ManagerInfoModel } from './models/manager-info.model';
import { AuditSharedService } from 'src/app/services/Audit/audit-shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-project-listing',
  templateUrl: './project-listing.component.html',
  styleUrls: ['./project-listing.component.css']
})
export class ProjectListingComponent implements OnInit {
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  tableColumns: Array<string> = ['auditId','projectName','technologyStack','startDate','endDate','managerName','lastAuditDate','auditFrequency','auditorName','actions']; 
  tableDataSource: MatTableDataSource<ProjectInfo>;
  projectInfos:Array<ProjectInfo> = [];
  deliveryManagers:Array<ManagerInfoModel> = [];
  totalRecordCount:number = 0;

  selectedAuditFrequency:number = -1;//default no selected
  auditFreqOptions:Array<AuditFrequencyModel> = [];
  hasAuditorRole:boolean = false;

  projectSearchForm:FormGroup;
  
  constructor(private readonly formBuilder:FormBuilder, private toasterService: ToastrService
                                                      , private projectService: ProjectListingService
                                                      , private authService: AuthServiceService
                                                      , private auditShareService:AuditSharedService
                                                      , private router:Router) {
  }

  ngOnInit(): void {
    this.hasAuditorRole = this.isUserAuditor();
    this.buildProjectSearchForm();

    this.getDeliveryManagers();
    this.bindProjects();
  }

  ngAfterViewInit() {
    this.initializePaginator();
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  initializePaginator()
  {
    if(this.tableDataSource){
      this.tableDataSource.paginator = this.paginator;
      this.tableDataSource.sort = this.sort;
    }
    else {
      setTimeout(() => {this.initializePaginator();}, 100);
    }
  }

  buildProjectSearchForm(){
    this.projectSearchForm = this.formBuilder.group({
      projectName:[''],
      deliveryManager:['-1'],
      startDate:[],
      endDate:['']
    });
  }

  resetFormData()
  {
    this.projectSearchForm.setValue({
      projectName:'',
      deliveryManager:-1,
      startDate:'',
      endDate:''
    });

    this.bindProjects();
    this.paginator.pageIndex = 0;
  }

  getAuditFrequencyOptions(){
    this.projectService.getAuditFrequencyOptions().subscribe(
      (responseData: Array<AuditFrequencyModel>) => {
        this.auditFreqOptions = responseData;
      },
      (error) => {
      }
    );
  }

  bindProjects()
  {
    this.getAuditFrequencyOptions();
    this.projectService.getAuditedProjects().subscribe(
      (responseData:AuditedProjectResult) => {
        this.projectInfos = responseData?.result
        this.tableDataSource = new MatTableDataSource<ProjectInfo>(this.projectInfos);
        this.totalRecordCount = this.projectInfos?.length;
      },
      (error) => {
      }
    ); 
  }

  searchProjects(){
    if(this.projectSearchForm.valid)
    {
      const filter = new ProjectFilter();
      filter.name = this.projectSearchForm.get('projectName')?.value;
      filter.deliveryManager = this.projectSearchForm.get('deliveryManager')?.value;
      filter.startDate = this.projectSearchForm.get('startDate')?.value;
      filter.endDate = this.projectSearchForm.get('endDate')?.value;
      
      this.projectService.searchProjects(filter).subscribe(
        (responseData:Array<ProjectInfo>) => {
          this.projectInfos = responseData;
          this.tableDataSource = new MatTableDataSource<ProjectInfo>(this.projectInfos);
        },
        (error) => {
          this.tableDataSource = new MatTableDataSource<ProjectInfo>(null);  
        }
      );
    }
    else{
       this.toasterService.error('Invalid form!');
    }
  }

  getDeliveryManagers(){
    this.projectService.getManagersName().subscribe(
      (responseData: Array<ManagerInfoModel>) =>{
        this.deliveryManagers = responseData;
      },
      (error) => {
      }
    );
  }

  readSearchFormData(): ProjectFilter
  {
    const filter = new ProjectFilter();
    filter.name = this.projectSearchForm.get('projectName')?.value;
    
    const managerId = parseInt(this.projectSearchForm.get('deliveryManager')?.value);
    filter.deliveryManager = isNaN(managerId) ? -1 : managerId;

    filter.startDate = this.projectSearchForm.get('startDate')?.value;
    filter.endDate = this.projectSearchForm.get('endDate')?.value;
    return filter;
  }


  get isFormValid(): boolean {
    const filter = this.readSearchFormData();
    if(filter?.name?.trim()?.length > 0 || filter?.deliveryManager > 0)
    {
      return true;
    }
    return false;
  }

  isUserAuditor(): boolean {
    const loginUserRole = this.authService.getRole();
    if(loginUserRole?.toLocaleLowerCase() === 'auditor')//set auditor role here
    {
      return true;
    }
    return true;//for the make it visible for all
  }

  navigateToProjectOverview(auditId:number){
    this.auditShareService.setAuditId(auditId);
    this.router.navigate(['/Audit Overview']);
  }

  editProject(auditId:number){
    this.auditShareService.setAuditId(auditId);
    this.router.navigate(['/Audit Overview']);
  }

}